import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "layout-topbar" }
const _hoisted_2 = { class: "topbar-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "topbar-separator" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "layout-breadcrumb viewname p-text-uppercase"
}
const _hoisted_8 = { class: "topbar-right" }
const _hoisted_9 = { class: "topbar-menu" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bell" }, null, -1)
const _hoisted_11 = { class: "topbar-badge" }
const _hoisted_12 = {
  key: 0,
  class: "notifications-menu fade-in-up"
}
const _hoisted_13 = { role: "menuitem" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user-plus" }, null, -1)
const _hoisted_15 = { class: "notification-item" }
const _hoisted_16 = { class: "notification-summary" }
const _hoisted_17 = { class: "notification-detail" }
const _hoisted_18 = { role: "menuitem" }
const _hoisted_19 = {
  href: "#",
  tabindex: "0"
}
const _hoisted_20 = {
  key: 1,
  class: "pi pi-user"
}
const _hoisted_21 = { class: "notification-item" }
const _hoisted_22 = { class: "notification-summary" }
const _hoisted_23 = { class: "notification-detail" }
const _hoisted_24 = {
  key: 1,
  class: "notifications-menu fade-in-up"
}
const _hoisted_25 = { class: "notification-item cursor-pointer" }
const _hoisted_26 = { class: "notification-summary" }
const _hoisted_27 = { class: "notification-detail" }
const _hoisted_28 = {
  key: 0,
  class: "p-error"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "profile-name" }
const _hoisted_32 = { class: "profile-menu fade-in-up" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_34 = { href: "#" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-power-off" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_AppMenu = _resolveComponent("AppMenu")!
  const _component_ZoomScreen = _resolveComponent("ZoomScreen")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        tabindex: "0",
        class: "menu-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMenuButtonClick && _ctx.onMenuButtonClick(...args)))
      }, _hoisted_4),
      _createVNode(_component_router_link, {
        to: `/${_ctx.$route.path.split('/')[1]}`,
        class: "horizontal-logo"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "horizontal-logo",
            src: _ctx.activityLogo,
            alt: _ctx.$t('workspaceLayout.dashboard')
          }, null, 8, _hoisted_5)
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_6,
      (_ctx.layoutMode !== 'horizontal')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.activity && `${_ctx.activity} - `) + " " + _toDisplayString(_ctx.$t(`workspaceLayout.${String(_ctx.$route.name)}`)), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_Avatar, {
        id: "logo-mobile",
        class: "mobile-logo",
        image: _ctx.activityLogo,
        alt: _ctx.$tm('workspaceLayout.dashboard')
      }, null, 8, ["image", "alt"])
    ]),
    _createVNode(_component_AppMenu, {
      model: _ctx.menu,
      layoutMode: _ctx.layoutMode,
      active: _ctx.menuActive,
      mobileMenuActive: _ctx.staticMenuMobileActive,
      "activity-logo": _ctx.activityLogo,
      onMenuClick: _ctx.onMenuClick,
      onMenuitemClick: _ctx.onMenuItemClick,
      onRootMenuitemClick: _ctx.onRootMenuItemClick
    }, null, 8, ["model", "layoutMode", "active", "mobileMenuActive", "activity-logo", "onMenuClick", "onMenuitemClick", "onRootMenuitemClick"]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("ul", _hoisted_9, [
        (_ctx.count.total)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              class: _normalizeClass(["notifications-item", { 'active-menuitem ': _ctx.topbarNotificationMenuActive }])
            }, [
              _createElementVNode("a", {
                href: "#",
                tabindex: "0",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTopbarNotificationMenuButtonClick && _ctx.onTopbarNotificationMenuButtonClick(...args)))
              }, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.count.total), 1)
              ]),
              (_ctx.count.invitations)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                    _createElementVNode("li", _hoisted_13, [
                      _createVNode(_component_router_link, {
                        to: "/workspace/activity",
                        tabindex: "0"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("workspaceLayout.newInvitation")), 1),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("workspaceLayout.count", {
                        count: _ctx.count.invitations,
                      }).replaceAll(_ctx.count.invitations > 1 ? "s" : "", "")), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responsible, (res) => {
                return (_openBlock(), _createElementBlock("ul", {
                  class: "notifications-menu fade-in-up",
                  key: res.id
                }, [
                  _createElementVNode("li", _hoisted_18, [
                    _createElementVNode("a", _hoisted_19, [
                      (res.user.image)
                        ? (_openBlock(), _createBlock(_component_Avatar, {
                            key: 0,
                            shape: "circle",
                            image: _ctx.getImage(res.user.image, 'users')
                          }, null, 8, ["image"]))
                        : (_openBlock(), _createElementBlock("i", _hoisted_20)),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("responsible.collaborators").replace("s", "")), 1),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("responsible.gone", {
                        name: res.user.name || res.user.email,
                      })), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.count.exp)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                    _createElementVNode("li", {
                      role: "menuitem",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToExpiration && _ctx.goToExpiration(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("stock.expiration")), 1),
                        _createElementVNode("div", _hoisted_27, [
                          (_ctx.stockExpNotifier.expired > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t(
                        `stock.stock${
                          _ctx.stockExpNotifier.expired > 1 ? "s" : ""
                        }Expired`,
                        {
                          count: _ctx.stockExpNotifier.expired,
                        }
                      )), 1))
                            : _createCommentVNode("", true),
                          (_ctx.stockExpNotifier.threshold > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.$t(
                        `stock.stock${
                          _ctx.stockExpNotifier.threshold > 1 ? "s" : ""
                        }Rupture`,
                        {
                          count: _ctx.stockExpNotifier.threshold,
                        }
                      )), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.Iam)
          ? (_openBlock(), _createElementBlock("li", {
              key: 1,
              class: _normalizeClass(["profile-item", { 'active-menuitem fadeInDown': _ctx.topbarUserMenuActive }])
            }, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onTopbarUserMenuButtonClick && _ctx.onTopbarUserMenuButtonClick(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.getImage(_ctx.Iam.image, 'users'),
                  alt: "locaa",
                  class: "profile-image"
                }, null, 8, _hoisted_30),
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.Iam.name), 1)
              ]),
              _createElementVNode("ul", _hoisted_32, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    "active-class": "active-route",
                    to: "/workspace/account"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("workspaceLayout.myAccount")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.logout()))
                }, [
                  _createElementVNode("a", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("logout")), 1)
                  ])
                ])
              ])
            ], 2))
          : _createCommentVNode("", true),
        _createVNode(_component_ZoomScreen, {
          class: "p-ml-2",
          pos: true
        })
      ])
    ])
  ]))
}